// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__nEyOO","snippets":"Projects_snippets__Y3Y43"};